import { color } from 'components/base/color';
import styled from 'styled-components';

export const TextBetween = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: normal;
  color: ${color.green};
  margin: 5px 0px;
`;
